import React from "react";
import { Box, Typography, styled } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Routes from "../../../../utils/Routes";
import Button from "../../../../components/Button";
import ReferralSubmission from "../../../../assets/images/ReferralSubmission.png";

function ReferralSubmissionScreen({ className }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (route) => {
    if (location.pathname === "/" + route) {
      window.location.reload();
    }
  };

  return (
    <div className={className}>
      <div className="main-container">
        <Box className="container">
          <div className="text">Referral</div>
          <Box className="imgContainer">
            <img src={ReferralSubmission} alt="Submission" className="img" />
            <Box sx={{ marginTop: "50px", textAlign: "center" }}>
              <Typography variant="h4" fontWeight={700}>
                Your referral has been
              </Typography>
              <Typography variant="h4" fontWeight={700}>
                submitted
              </Typography>
            </Box>
          </Box>

          <Box className="buttonContainer">
            <Button
              label="Home"
              variant="primary"
              onClick={() => handleNavClick(Routes.Home)}
            />

            <Button
              label="My Referrals"
              variant="outlined"
              onClick={() => navigate("/" + Routes.Track)}
            />
          </Box>
        </Box>
      </div>
    </div>
  );
}

export default styled(ReferralSubmissionScreen)(() => ({
  ".main-container": {
    display: "flex",
    justifyContent: "center",
  },
  ".text": {
    fontWeight: 700,
    fontSize: 60,
    letterSpacing: 0,
    color: "#234000",
  },
  ".container": {
    textAlign: "center",
    padding: "20px",
    maxWidth: "400px",
  },
  ".body": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    maxWidth: "400px",
    // height: "80vh",
  },
  ".buttonContainer": {
    // marginTop: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  ".img": {
    width: "235px",
    height: "163px",
  },
  ".imgContainer": {
    marginTop: "50px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
}));
